import { Modal } from "antd";
import { observer } from "mobx-react-lite";
import { useIntl } from "react-intl";

import { AgentsStore } from "@/stores";

import AgentCreateForm from "./agent-create-short-form";

type TProps = {
  agentsStore: AgentsStore;
};

function AgentCreateShortModal({ agentsStore }: TProps) {
  const { agentCreateStore } = agentsStore;

  const intl = useIntl();

  return (
    <Modal
      title={intl.formatMessage({ defaultMessage: "New agent" })}
      open={agentCreateStore.modalShort.isOpen}
      onCancel={agentCreateStore.modalShort.close}
      width={720}
      footer={null}
      destroyOnClose={true}
    >
      <AgentCreateForm agentsStore={agentsStore} />
    </Modal>
  );
}

export default observer(AgentCreateShortModal);
